import { createIconComponent } from '../../factory/create-icon-component';
export const BuyIcon = createIconComponent(
  'BuyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.29296 9.83096C3.53933 7.51219 3.66252 6.35281 4.09867 5.43188C4.7857 3.98124 6.02531 2.86635 7.54042 2.33644C8.50228 2.00003 9.66819 2.00003 12 2.00003C14.3318 2.00003 15.4977 2.00003 16.4596 2.33644C17.9747 2.86635 19.2143 3.98124 19.9013 5.43188C20.3375 6.35281 20.4607 7.51219 20.707 9.83095L20.9434 12.056C21.2676 15.107 21.4297 16.6325 21.0382 17.8443C20.5141 19.467 19.3242 20.79 17.7659 21.4827C16.6022 22 15.0682 22 12 22C8.93184 22 7.39777 22 6.23406 21.4827C4.67581 20.79 3.48593 19.467 2.96176 17.8443C2.5703 16.6325 2.73239 15.107 3.05655 12.056L3.29296 9.83096Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00012 7.00003V9.00003C9.00012 10.6569 10.3433 12 12.0001 12C13.657 12 15.0001 10.6569 15.0001 9.00003V7.00003"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
